import React from 'react'
import './Badge.scoped.sass'
import classNames from 'classnames'

export function Badge (props) {
  const {
    children,
    onClick,
    type = ''
  } = props
  return <span onClick={onClick} className={classNames('badge', { [type]: type })}>{children}</span>
}
